import { useWindowDimensions } from 'react-native';
import { LayoutBreakpoints } from '@/constants/LayoutBreakpoints';

/**
 * Whether the viewport is at or above `minWidth` (a `LayoutBreakpoints` value).
 *
 * Use this to *conditionally render* breakpoint-specific nodes instead of
 * toggling their `display` with NativeWind `hidden md:flex` / `hidden xl:flex`:
 * a phone-`display:none` node that re-renders crashes the iOS New Architecture
 * renderer (RN #52349). Keeping the node out of the tree on phone avoids it.
 *
 * @example
 * const isDesktop = useIsWidthUp(LayoutBreakpoints.desktop);
 * return isDesktop ? <WideVariant /> : <PhoneVariant />;
 */
export const useIsWidthUp = (minWidth: number): boolean => {
  const { width } = useWindowDimensions();
  return LayoutBreakpoints.isWidthUp(width, minWidth);
};
